import React, { Component } from 'react'
import style from './style.module.less'
import Edit from './edit'
import Cards from './cards'
import { observer } from 'mobx-react'

@observer
class Index extends Component {
  render() {
    const { store } = this.props
    return (
      <div className={style.right}>
        <Edit store={store} />
        <Cards store={store} />
      </div>
    )
  }
}

export default Index
